import { useTranslation } from "react-i18next";
import { DocumentCenter } from "../../../../components/dashboard/documents/document-center";

export const ServiceAgreementDocuments = (props) => {
  const { moduleParam } = props;
  const { t } = useTranslation();

  return (
    <DocumentCenter
      subtitle={t("service.agreements.documents.pdf_only")}
      module="service_agreement_documents"
      allowedFileTypes="application/pdf"
      moduleParam={moduleParam}
    />
  );
};
